var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInicio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2687 11.9574L12.2894 2.40467C12.0001 2 11.5173 2.09388 11.2114 2.40405L1.23145 11.9574M20.2501 10.4367V21.4992C20.2501 21.897 20.092 22.2785 19.8107 22.5598C19.5294 22.8411 19.1479 22.9992 18.7501 22.9992H14.2501C13.8359 22.9992 13.5001 22.6634 13.5001 22.2492V15.8742C13.5001 15.7747 13.4606 15.6793 13.3902 15.609C13.3199 15.5387 13.2245 15.4992 13.1251 15.4992H10.3751C10.2756 15.4992 10.1802 15.5387 10.1099 15.609C10.0396 15.6793 10.0001 15.7747 10.0001 15.8742V22.2492C10.0001 22.6634 9.66428 22.9992 9.25007 22.9992H4.75007C4.35224 22.9992 3.97071 22.8411 3.68941 22.5598C3.4081 22.2785 3.25007 21.897 3.25007 21.4992V10.4367M18.7501 8.58918V3.49917C18.7501 3.08496 18.4143 2.74917 18.0001 2.74917H15.7501C15.3359 2.74917 15.0001 3.08496 15.0001 3.49917V4.99949",
    stroke: "#474747",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInicio);
export default __webpack_public_path__ + "static/media/inicio.0416ca98565703ff9607628b8b50a3cf.svg";
export { ForwardRef as ReactComponent };